<div class="mdc-layout-grid__inner center">
	<div class="mdc-layout-grid__cell--span-12">
		<mat-icon class="large">cancel</mat-icon>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<h2>{{ locale.translations['payment']['n338'] }}</h2>
		<p>{{ locale.translations['payment']['n339'] }}</p>
	</div>

	<div class="mdc-layout-grid__cell--span-12" *ngIf="!embedded">
		<a mat-flat-button color="primary" [routerLink]="adID ? ['/ad/' + adID] : ['.']">{{ locale.translations['place-ad']['place-ad-success']['n122'] }}</a>
	</div>
</div>
